import { useEffect } from "react";

function setMeta(name: string, content: string) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function useDocumentTitle(title: string, description?: string, keywords?: string) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      setMeta("description", description);
    }
    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, keywords]);
}